export default __webpack_public_path__ + "6c107bea32ce3f4cb090ecfb4fc77375.svg";